import React from 'react';
import { uspsProfessional } from '../data/mockData';
import * as Icons from 'lucide-react';

const ProfessionalAssistanceSection = () => {
  return (
    <section className="relative py-20 bg-gradient-to-b from-gray-900 via-[#1a1a2e] to-gray-900 overflow-hidden">
      {/* Decorative Circles */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full opacity-5 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#FF9900] rounded-full opacity-5 blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Heading */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <div className="inline-block bg-gradient-to-r from-[#FF9900]/20 to-orange-600/20 border border-[#FF9900]/30 text-[#FF9900] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Professional Assistance
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Expert Trademark Attorney Services | Professional USPTO Filing
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed">
            Professional trademark registration assistance with expert trademark lawyers providing online trademark filing, federal trademark application support, comprehensive trademark search services, USPTO trademark office filing, and complete trademark legal services for businesses nationwide.
          </p>
        </div>

        {/* 8 USPs Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {uspsProfessional.map((usp, index) => {
            const IconComponent = Icons[usp.icon];
            return (
              <div
                key={usp.id}
                className="group bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl p-6 hover:shadow-2xl hover:shadow-[#FF9900]/10 transition-all duration-300 transform hover:-translate-y-2 border border-white/10 hover:border-[#FF9900]/30"
                style={{
                  animationDelay: `${index * 50}ms`
                }}
              >
                <div className="w-14 h-14 bg-gradient-to-r from-[#FF9900] to-orange-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  {IconComponent && <IconComponent className="w-7 h-7 text-black" />}
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{usp.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{usp.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProfessionalAssistanceSection;